import { Component, ViewEncapsulation } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { TranslateModule } from '@ngx-translate/core';
import { ButtonComponent } from '@sc/ui-components';

export interface NotifyAfterDragCalendarDialogData {
  title: string;
  text: string;
}

@Component({
  selector: 'sc-notify-after-drag-calendar-dialog',
  styleUrls: ['./notify-after-drag-calendar.dialog.component.scss'],
  encapsulation: ViewEncapsulation.None,
  imports: [ButtonComponent, TranslateModule],
  template: `
    <div class="container">
      <h1
        mat-dialog-title
        class="sc-design-text-3 dialog-question-text"
        id="notify-after-drag-calendar-title-id"
        [innerHTML]="
          'Planning.dialogs.notifyAfterDragCalendar.body' | translate
        "
      ></h1>
      <div class="dialog-actions-container">
        <sc-button
          id="closeBtn"
          buttonType="secondary"
          leftIcon="close"
          (click)="onCloseClick()"
          >{{
            'Planning.dialogs.notifyAfterDragCalendar.noBtn' | translate
          }}</sc-button
        >
        <sc-button
          id="validateBtn"
          buttonType="primary"
          leftIcon="mail"
          (click)="onValidateClick()"
          >{{
            'Planning.dialogs.notifyAfterDragCalendar.yesBtn' | translate
          }}</sc-button
        >
      </div>
    </div>
  `,
})
export class NotifyAfterDragCalendarDialogComponent {
  constructor(
    private readonly dialogRef: MatDialogRef<NotifyAfterDragCalendarDialogComponent>
  ) {}

  onCloseClick() {
    this.dialogRef.close('cancel');
  }

  onValidateClick() {
    this.dialogRef.close('notify');
  }
}
